<template>
  <v-container class="attachment-wrap pa-0 ma-0 fluid fill-height">
    <div class="attachment-layout">
      <div class="attachment-top">
        <v-card-text class="pa-0 pr-1 text-body-2 mb-3 attachment-subtitle">
          {{ $t("addDocuments") }}
        </v-card-text>

        <div
          class="attachment-dropzone mb-3"
          @click="openPicker"
          @dragover.prevent
          @drop.prevent="handleDrop"
        >
          <v-icon color="primary" size="28">mdi-cloud-upload-outline</v-icon>
          <div class="mt-2 text-body-2 font-weight-medium">
            {{ $t("Drag and drop files here") }}
          </div>
          <div class="text-caption attachment-hint">
            {{ $t("or click to select a file") }}
          </div>
        </div>

        <file-picker
          ref="refFilePicker"
          v-model="attachments"
          :label="$t('addDocuments')"
          :multiple="true"
          :type-prop="attachmentType"
          :val="refIdForUpload && attachments ? attachments : null"
        />

        <div class="attachment-table-toolbar mt-3">
          <div class="text-body-2 grey--text text--darken-1 attachment-count-badge">
            {{
              hasFiles ? `${attachmentRows.length} فایل انتخاب شده` : "فایلی انتخاب نشده"
            }}
          </div>
          <v-btn
            v-if="attachmentRows.length > 1"
            outlined
            small
            color="error"
            class="clear-btn"
            :disabled="!hasFiles"
            @click="clearAll"
          >
            <v-icon small class="ml-1">mdi-trash-can-outline</v-icon>
            {{ $t("clearAll") }}
          </v-btn>
        </div>
      </div>

      <div class="attachment-table-scroll">
        <table class="attachment-table">
          <thead>
            <tr>
              <th>{{ $t("preview") }}</th>
              <th>{{ $t("fileName") }}</th>
              <th>{{ $t("fileType") }}</th>
              <th>{{ $t("size") }}</th>
              <th>{{ $t("operations") }}</th>
            </tr>
          </thead>
          <tbody v-if="attachmentRows.length">
            <tr v-for="(row, index) in attachmentRows" :key="row.key">
              <td>
                <div class="preview-cell" @click="openAttachment(row)">
                  <v-img
                    v-if="row.isImage"
                    :src="row.link"
                    max-width="36"
                    max-height="36"
                    contain
                  />
                  <v-icon v-else size="22" color="grey darken-1">mdi-file-outline</v-icon>
                </div>
              </td>
              <td class="file-name-cell" :title="row.name">{{ row.name }}</td>
              <td>{{ row.type }}</td>
              <td>{{ row.sizeText }}</td>
              <td>
                <v-btn icon x-small color="primary" @click="openAttachment(row)">
                  <v-icon small>mdi-open-in-new</v-icon>
                </v-btn>
                <v-btn icon x-small color="pink" @click="removeAttachment(index)">
                  <v-icon small>mdi-close-circle</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5" class="empty-row">{{ $t("no-data-found") }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="attachment-footer">
        <v-btn
          color="primary"
          height="40"
          :loading="loading"
          :disabled="!refIdForUpload || !hasFiles"
          @click="submitAttachments"
        >
          {{ $t("Submit Attachments") }}
        </v-btn>
      </div>
    </div>
  </v-container>
</template>

<script>
import General from "../../../../../../../Mixins/general";
import filePicker from "../../../../../components/general/filePicker/index";

export default {
  name: "TableAttachment",
  components: { filePicker },
  mixins: [General],
  props: {
    attachmentType: {
      type: String,
      default: "salary",
    },
  },
  data() {
    return {
      attachments: null,
      loading: false,
      workshopSalaryId: null,
    };
  },
  computed: {
    salaryId() {
      const id = this.$route?.query?.id;
      return id ? Number(id) : null;
    },
    refIdForUpload() {
      return this.workshopSalaryId != null ? this.workshopSalaryId : this.salaryId;
    },
    hasFiles() {
      return Array.isArray(this.attachments) && this.attachments.length > 0;
    },
    attachmentRows() {
      if (!this.hasFiles) return [];
      return this.attachments.map((file, index) => {
        const name = file?.name || file?.title || this.$t("haveNot");
        const extensionRaw =
          file?.extension || (name.includes(".") ? "." + name.split(".").pop() : "");
        const extension = String(extensionRaw || "")
          .replace(/\s/g, "")
          .toLowerCase();
        const type = extension || file?.type || this.$t("haveNot");
        const size = Number(file?.size || 0);
        const link = file?.url || file?.link || null;
        const isImage = [".jpg", ".jpeg", ".png", ".bmp", ".gif", ".webp"].includes(
          extension
        );
        return {
          key: file?._id || file?.id || `${name}-${index}`,
          name,
          type,
          sizeText: this.formatSize(size),
          size,
          link,
          isImage,
        };
      });
    },
  },
  mounted() {
    this.loadExistingAttachments();
  },
  methods: {
    loadExistingAttachments() {
      if (!this.salaryId) return;
      this.$axios
        .get(this.$endpoint + "salary/" + this.salaryId, {
          params: {
            workshop: this.$route?.query?.hrm_workshop_id,
          },
        })
        .then((res) => {
          const root = res?.data || {};
          const ws = root.workshop_salary || root.workshopSalary || null;
          if (ws && ws.id != null && ws.id !== "") {
            this.workshopSalaryId = Number(ws.id);
          } else {
            this.workshopSalaryId = null;
          }
          const docs = ws?.docs;
          let loaded = null;
          if (Array.isArray(docs)) {
            loaded = docs;
          } else {
            loaded =
              root.attachments ||
              root.data?.attachments ||
              root.salary?.attachments ||
              root.result?.attachments ||
              root.data?.data?.attachments ||
              [];
          }
          this.attachments = Array.isArray(loaded) && loaded.length > 0 ? loaded : null;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
    },
    openPicker() {
      if (this.$refs.refFilePicker?.handleFileImport) {
        this.$refs.refFilePicker.handleFileImport();
      }
    },
    handleDrop(e) {
      const files = Array.from(e.dataTransfer?.files || []);
      if (!files.length) return;
      const previous = Array.isArray(this.attachments) ? [...this.attachments] : [];
      files.forEach((file) => {
        if (file.size > 500000) {
          this.$emit("snackbar", {
            text: this.$t("fileShouldBeLessThan500KB"),
            color: "pink",
          });
          return;
        }
        file.link = URL.createObjectURL(file);
        file.extension = ". " + file.name.split(".").pop();
        file.title = file.name.split(".")[0];
        file._id = file.size + "" + file.lastModified;
        file.iconURL = "";
        previous.push(file);
      });
      this.attachments = previous;
    },
    clearAll() {
      this.attachments = null;
    },
    removeAttachment(index) {
      if (!Array.isArray(this.attachments)) return;
      const next = [...this.attachments];
      next.splice(index, 1);
      this.attachments = next.length ? next : null;
    },
    openAttachment(row) {
      if (!row?.link) return;
      window.open(
        row.link,
        "_blank",
        "toolbar=yes,scrollbars=yes,resizable=yes,width=600,height=500"
      );
    },
    formatSize(bytes) {
      if (!bytes || Number.isNaN(bytes)) return "-";
      if (bytes < 1024) return `${bytes} B`;
      if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
      return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    },
    submitAttachments() {
      if (!this.refIdForUpload || !this.attachments || this.attachments.length === 0)
        return;
      this.loading = true;
      const formData = new FormData();
      this.attachments.forEach((file, i) => {
        formData.append(`files[${i}]`, file);
        formData.append(`selectedFile[${i}]`, JSON.stringify(file));
      });
      formData.append("refId", this.refIdForUpload);
      formData.append("type", this.attachmentType);
      formData.append("select", "fileUpload");
      this.$axios
        .post(this.$endpoint + "createdetail", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          this.$emit("snackbar", {
            text: this.$t("alert-register-success"),
            color: "success",
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.loading = false;
          this.loadExistingAttachments();
        });
    },
  },
};
</script>

<style scoped>
.attachment-wrap {
  height: 100% !important;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.attachment-layout {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  /* max-width: 980px; */
}

.attachment-top {
  flex: 0 0 auto;
}

.attachment-subtitle {
  color: #6b7280;
}

.attachment-dropzone {
  border: 1.5px dashed #b0b7c3;
  border-radius: 4px;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  cursor: pointer;
  background: #f7f7f8;
  transition: all 0.2s ease;
  max-width: 520px;
}

.attachment-dropzone:hover {
  border-color: #8d97a6;
  background: #f1f2f4;
}

.attachment-hint {
  color: #6b7280;
}

.attachment-wrap ::v-deep .v-btn.primary--text {
  display: none;
}

.attachment-wrap ::v-deep .v-list {
  display: none;
}

.attachment-table-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.attachment-count-badge {
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  padding: 6px 10px;
}

.clear-btn {
  border-color: #ef9a9a !important;
  color: #d32f2f !important;
  background: #fff5f5 !important;
}

.attachment-table-scroll {
  flex: 1 1 auto;
  min-height: 100px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  border: 1px solid #d9dde4;
  border-radius: 4px;
  margin-top: 8px;
}

.attachment-table {
  width: 100%;
  min-height: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.attachment-table th,
.attachment-table td {
  padding: 10px;
  border-bottom: 1px solid #e6e9ef;
  text-align: right;
  font-size: 12px;
}

.attachment-table th {
  position: sticky;
  top: 0;
  background: #f3f4f6;
  z-index: 1;
}

.file-name-cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.preview-cell {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  cursor: pointer;
  background: #fff;
}

.empty-row {
  text-align: center !important;
  color: #8a94a6;
  padding: 20px !important;
  height: 100%;
  vertical-align: middle;
}

.attachment-footer {
  flex: 0 0 auto;
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 12px 0 4px;
  background: #fff;
}

@media (max-height: 760px) {
  .attachment-dropzone {
    min-height: 88px;
  }
}
</style>
